import React from 'react'
import { StickyTable } from '../../components/StickyTable'
import { getResourcesList } from '../../services/resources/getResources'
import { Divider } from '@mui/material';
import { Check, Close } from '@mui/icons-material';
import { ResourceActions } from '../ResourceActions';
import { getCategoriesList } from '../../services/categories/getCategories';
import { getResourceTypes } from '../../services/resourceTypes/getResourceTypes';
import { getLocations } from '../../services/locations/getLocations';
import theme from '../../theme/theme';
import { SingleGallery } from '../../components/SingleGallery';
import { ButtonsWrapper, Container, HeaderWrapper, IconSection, MainHeader, TableHeader, Title } from './styles';
import { CategoryActions } from '../CategoryActions';
import { TypeActions } from '../TypeActions';
import { LocationActions } from '../LocationActions';
import { deleteResource } from '../../services/resources/deleteResource';
import { Menu } from '../../components/Menu';
import { deleteLocation } from '../../services/locations/deleteLocation';
import { deleteCategory } from '../../services/categories/deleteCategory';
import { RequestModal } from '../../components/RequestModal';
import Spinner from '../../components/Spinner/Spinner';
import { ToggleSwitch } from '../../components/ToggleSwitch';
import { reactivateResource } from '../../services/resources/putResources';
import { reactivatePlace } from '../../services/locations/putLocation';

const AdminPanel = () => {
  // ------------------- JWT -------------------
  const jwt = localStorage.getItem('jwt');

  const configCategories = [
    {name: 'Recursos',},
    {name: 'Categorías',},
    {name: 'Tipos',},
    {name: 'Ubicaciones',},
  ];

  // ------ States ------
  const [tableFeatures, setTableFeatures] = React.useState<any>([]);
  const [tableData, setTableData] = React.useState<any>([]);
  const [title, setTitle] = React.useState('');

  const [alertTitle, setAlertTitle] = React.useState('');
  const [alertMessage, setAlertMessage] = React.useState('');
  const [openAlert, setOpenAlert] = React.useState(false);

  const handleCloseAlert = () => {
    setOpenAlert(false);
  }

  const [loading, setLoading] = React.useState(false);

  const [deletionAlert, setDeletionAlert] = React.useState(false);
  const [doDelete, setDoDelete] = React.useState(false);

  const resourceCols = [
    { id: 'status', label: 'Estado', minWidth: 80 },
    { id: 'activate', label: 'Activar', minWidth: 80 },
    { id: 'name', label: 'Nombre', minWidth: 120 },
    { id: 'images', label: 'Imágenes', minWidth: 120 },
    { id: 'description', label: 'Descripción', minWidth: 120 },
    { id: 'maxTime', label: 'Tiempo límite de reserva', minWidth: 120 },
    // { id: 'timeMeasure', label: 'Unidad de tiempo', minWidth: 70 },
    // { id: 'onSiteOnly', label: 'En Sitio', minWidth: 170 },
    { id: 'location', label: 'Ubicación', minWidth: 120 },
    { id: 'resourceType', label: 'Tipo', minWidth: 120 },
    { id: 'edit', label: 'Editar', minWidth: 120 }
  ]

  const categoryCols = [
    { id: 'name', label: 'Nombre', minWidth: 170 },
    { id: 'image', label: 'Imagen', minWidth: 170 },
    // { id: 'actions', label: 'Acciones', minWidth: 170 }
  ]

  const typeCols = [
    { id: 'name', label: 'Nombre', minWidth: 170 },
    { id: 'category', label: 'Categoría', minWidth: 170 },
    { id: 'actions', label: 'Acciones', minWidth: 170 }
  ]

  const locationCols = [
    { id: 'status', label: 'Estado', minWidth: 80 },
    { id: 'activate', label: 'Activar', minWidth: 80 },
    { id: 'name', label: 'Nombre', minWidth: 170 },
    { id: 'building', label: 'Edificio', minWidth: 170 },
    { id: 'floor', label: 'Piso', minWidth: 170 },
    { id: 'room', label: 'Sala', minWidth: 170 },
    { id: 'description', label: 'Descripción', minWidth: 170 },
    { id: 'actions', label: 'Acciones', minWidth: 170 }
  ]

  // ------ Requests ------
  const fetchResources = async () => {
    setLoading(true);
    try {
      const response = await getResourcesList(jwt!);
      handleResourceData(response.data);
    } catch (err) {
      console.log(err);
    }
  }

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await getCategoriesList(jwt!);
      handleCategoryData(response.data);
    } catch (err) {
      console.log(err);
    }
  }

  const fetchTypes = async () => {
    setLoading(true);
    try {
      const response = await getResourceTypes(jwt!);
      handleTypeData(response.data);
    } catch (err) {
      console.log(err);
    }
  }

  const fetchLocations = async () => {
    setLoading(true);
    try {
      const response = await getLocations(jwt!);
      handleLocationData(response.data);
    } catch (err) {
      console.log(err);
    }
  }

  function isActive(active: any) {
    if (!active) {
      return <Check sx={{ color: theme.color.lemon, fontSize: '36px' }} />;
    } else {
      return <Close sx={{ color: theme.color.ruby, fontSize: '36px' }} />;
    }
  }

  function processLocationStr(locationStr: string): string {
    const location = locationStr.split(",");
    
    let place: string;

    if (location[2] === " Sin edificio asignado" || location[2] === " N/A") {
        place = location[1];
    } else {
        place = `${location[1]} \nEdificio: ${location[2]} \nPiso: ${location[3]} \nSalón: ${location[4]}`;
    }

    console.log(location[2]);  // ¿Es necesario imprimir esto aquí?

    return place;
}

  const reestablishResource = async (id: any) => {
    try {
      await reactivateResource(jwt!, id);
      setAlertTitle("Recurso activado!");
      setAlertMessage("Recurso activado con éxito.");
      fetchResources();
      setOpenAlert(true);
    } catch (error) {
      console.error('An error occurred while reactivating the resource:', error);
    }
  }

  const reestablishLocation = async (id: any) => {
    try {
      await reactivatePlace(id);
      setAlertTitle("Ubicación activada!");
      setAlertMessage("Ubicación activada con éxito.");
      fetchLocations();
      setOpenAlert(true);
    } catch (error) {
      console.error('An error occurred while reactivating the location:', error);
    }
  }

  const deleteAction = async (id: any, kind: string) => {
    if (kind === 'Recursos') {
      try {
        const response = await deleteResource(jwt!, id);
        setAlertTitle("¡Recurso desactivado!");
        setAlertMessage("Recurso desactivado con éxito.");
        fetchResources();
      } catch (error) {
        console.error('An error occurred while deleting the resource:', error);
        setAlertTitle("Error");
        setAlertMessage("Error al eliminar el recurso.");
      }
    } else if (kind === 'Categorías') {
      try {
        const response = await deleteCategory(jwt!, id);
        setAlertTitle("¡Categoría eliminada!");
        setAlertMessage("Categoría eliminada con éxito.");
        fetchCategories();
      } catch (error) {
        console.error('An error occurred while deleting the category:', error);
        setAlertTitle("Error");
        setAlertMessage("Error al eliminar la categoría.");
      }
    } else if (kind === 'Tipos') { 
      // setAlertTitle("Tipo pendiente de eliminar");
      // setAlertMessage("Not implemented yet.");
    } else if (kind === 'Ubicaciones') {
      try {
        const response = await deleteLocation(jwt!, id);
        setAlertTitle("¡Ubicación desactivada!");
        setAlertMessage("Ubicación desactivada con éxito.");
        fetchLocations();
      }
      catch (error) {
        console.error('An error occurred while deleting the location:', error);
        setAlertTitle("Error");
        setAlertMessage("Error al eliminar la ubicación.");
      }
    } else {
      console.log("Error: kind not found.");
      setAlertTitle("Error");
      setAlertMessage("Ocurrió un error al eliminar el elemento.");
    }

    setOpenAlert(true);
  };

  // ------ Handle Data ------
  const handleResourceData = (response: any) => {
    const resourceRows = response.map((item: any) => {
      // Extract URLs from the 'images' property of each item
      const imageUrls = item.images.map((image: any) => image.url);

      const limitedDescription = item.description.length > 80 ? item.description.substring(0, 80) + "..." : item.description;

      return {
        status: isActive(item.deleted),
        activate: <ToggleSwitch
          checked={!item.deleted}
          onChange={() => {
            if (item.deleted) {
              reestablishResource(item.id);
            } else {
              deleteAction(item.id, 'Recursos');
            }
          }} />,
        name: item.name,
        description: limitedDescription,
        maxTime: `${item.max_reservation_time} ${item.max_reservation_measure === 'day' ? 'día(s)' : 'hora(s)'}`,
        timeUnits: item.reservation_measure,
        images: <SingleGallery images={imageUrls} width='150px' height='150px' />,
        location: processLocationStr(item.location),
        resourceType: item.resource_type,
        code: item.id,
        edit:
          <ResourceActions
            action={'edit'}
            resourceObj={item}
            onResponse={fetchResources}
          />
      };
    });

    setTitle('Recursos');
    setTableData(resourceRows);
    setTableFeatures(resourceCols);
    setLoading(false);
  };


  const handleCategoryData = (response: any) => {
    // setTableData([]);
    const categoryRows = response.map((category: any) => ({
      name: category.name,
      image:
        <img src={category.image} alt={category.name} style={{ width: 'auto', height: '60px' }} />,
      actions:
        <ButtonsWrapper>
          <CategoryActions
            action={'edit'}
            categoryObj={category}
            onResponse={fetchCategories}
          />
          {/* <Button
            onClick={() => deleteAction(category.id, 'Categorías')}
          >
            <Delete sx={{ color: theme.color.navy, fontSize: '2rem' }} />
          </Button> */}
        </ButtonsWrapper>,
      code: category.id,
    }));

    setTitle('Categorías');
    setTableFeatures(categoryCols);
    setTableData(categoryRows);
    // setCategoryData(categoryRows);
    setLoading(false);
  };

  const handleTypeData = (response: any) => {
    // setTableData([]);
    const typeRows = response.map((type: any) => ({
      name: type.name,
      category: type.category,
      actions:
        <ButtonsWrapper>
          <TypeActions
            action={'edit'}
            typeObj={type}
            onResponse={fetchTypes}
          />
          {/* <Button
            onClick={() => deleteAction(type.id, 'Tipos')}
          >
            <Delete sx={{ color: theme.color.navy, fontSize: '2rem' }} />
          </Button> */}
        </ButtonsWrapper>,
      code: type.id,
    }));

    setTitle('Tipos');
    setTableFeatures(typeCols);
    setTableData(typeRows);
    // setTypeData(typeRows);
    setLoading(false);
  };

  const handleLocationData = (response: any) => {
    const filteredResponse = response.filter((location: any) => location.id !== 1000);
    const locationRows = filteredResponse.map((location: any) => {
      const limitedDescription = location.description.length > 80 ? location.description.substring(0, 70) + "..." : location.description;

      return {
      status: isActive(location.deleted),
      activate: <ToggleSwitch
        checked={!location.deleted}
        onChange={() => {
          if (location.deleted) {
            reestablishLocation(location.id);
          } else {
            deleteAction(location.id, 'Ubicaciones');
          }
        }} />,
      name: location.name,
      building: location.building,
      floor: location.floor,
      room: location.room,
      description: limitedDescription,
      actions:
        <ButtonsWrapper>
          <LocationActions
            action={'edit'}
            locationObj={location}
            onResponse={fetchLocations}
          />
        </ButtonsWrapper>,
      code: location.id,
    }});

    setTitle('Ubicaciones');
    setTableFeatures(locationCols);
    setTableData(locationRows);
    // setLocationData(locationRows);
    setLoading(false);
  };

  const handleSearch = (query: string) => {
    const filtered = tableData.filter(
      (item: any) =>
        item.name.toLowerCase().includes(query.toLowerCase()) ||
        item.description.toLowerCase().includes(query.toLowerCase()) ||
        item.location.toLowerCase().includes(query.toLowerCase()) ||
        item.resourceType.toLowerCase().includes(query.toLowerCase())
    );
    setTableData(filtered);
  }

  // ------ Main Handler ------
  const handleConfigSection = (category: string) => {
    setLoading(true);
    if (category === 'Recursos') {
      fetchResources();
    } else if (category === 'Categorías') {
      fetchCategories();
    } else if (category === 'Tipos') {
      fetchTypes();
    } else if (category === 'Ubicaciones') {
      fetchLocations();
    }
  };

  // ------ Use Effects ------
  React.useEffect(() => {
    setLoading(true);
    fetchResources();
  }, []);

  React.useEffect(() => {
  }, []);

  return (
    <>
    <Container>
      {deletionAlert &&
        <RequestModal
          title={'Confirmar eliminación'}
          description={'¿Está seguro que desea eliminar este elemento?'}
          onCancel={() => {
            setDeletionAlert(false);
          }}
          type={'verify'}
          onConfirm={() => {
            setDeletionAlert(false);
            setDoDelete(true);
            deleteAction(0, '');
          }}
        />
      }
      {
        openAlert &&
        <RequestModal
          title={alertTitle}
          description={alertMessage}
          onConfirm={handleCloseAlert}
        />
      }
      <MainHeader><Title>Panel de configuración</Title></MainHeader>
      <Divider sx={{ marginBottom: '20px' }} />
      </Container>
      <IconSection>
        <Menu
          categories={configCategories}
          onCategorySelect={handleConfigSection}
        />
      </IconSection>
      <Container>
      <HeaderWrapper>
        <TableHeader>{title}</TableHeader>
        {
          title === 'Recursos' ?
            <ResourceActions
              action={'create'}
              onResponse={fetchResources}
            />
            // : (
            //   title === 'Categorías' ?
            //     <CategoryActions
            //       action={'create'}
            //       onResponse={fetchCategories}
            //     />
                : (
                  title === 'Tipos' ?
                    <TypeActions
                      action={'create'}
                      onResponse={fetchTypes}
                    />
                    : (
                      title === 'Ubicaciones' ?
                        <LocationActions action={'create'}
                          onResponse={fetchLocations}
                        />
                        : null
                    )
                )
            // )
        }
      </HeaderWrapper>
      {/* {title === 'Recursos' ?
        <SearchBar 
          onSearch={handleSearch} 
          width='90%'
        />
        : null
      } */}
      <Divider sx={{ marginBottom: '20px' }} />
      {
        loading ?
          <Spinner />
          :
          tableData.length === 0 ?
            <p>No hay elementos para mostrar.</p>
            :
            // want to update table after clicking on delete button
            // <StickyTable columns={tableFeatures} rows={tableData} key={tableData} />
            <StickyTable columns={tableFeatures} rows={tableData} key={tableData} />
        // <StickyTable columns={tableFeatures} rows={tableData} />
      }
    </Container>
    </>
  )
}

export default AdminPanel;